module.exports = __webpack_public_path__ + "img/wanyuan.e86e5bc4.png";